import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';

import { PageHeaderMeta } from '@/components/PageHeaderMeta/PageHeaderMeta';
import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';
import { useAppSelector } from '@/redux/hooks';
import { getBaseUrl } from '@/redux/modules/config';
import { getItemSummaryFirstImageUrl } from '@/redux/modules/item/summary/itemSummary.selectors';
import { addImageParams, logoUrl } from '@/utils/urls';

type Props = {
    collectionId: number;
    collectionLabel: string;
    collectionName: string;
    itemId: number;
};

const CuratedCollectionPageHeaderMeta = ({ collectionId, collectionLabel, collectionName, itemId }: Props) => {
    const baseUrl = useAppSelector(getBaseUrl);
    const { formatMessage } = useIntl();
    const firstPhoto = useAppSelector((state) => getItemSummaryFirstImageUrl(state, itemId));
    const imageUrl = addImageParams({ url: firstPhoto, width: 512 });

    return (
        <PageHeaderMeta
            canonical={`${baseUrl}/featured/${collectionName}/${collectionId}`}
            description={formatMessage({ id: 'collection.title' }, { collectionLabel })}
            imageUrl={imageUrl || logoUrl}
            title={useAddNotificationCountToTitle(formatMessage({ id: 'collection.title' }, { collectionLabel }))}
        />
    );
};

export default React.memo<Props>(CuratedCollectionPageHeaderMeta);
